import classNames from 'classnames';
import * as React from 'react';
export const RadioContext = React.createContext({ radioGroup: {} });
const Radio = ({ className, value, style, unlabelled, ...rest }) => {
    const classes = classNames('ixu-radio', className);
    const Wrapper = unlabelled
        ? (props) => React.createElement("div", { ...props })
        : (props) => React.createElement("label", { ...props });
    return (React.createElement(RadioContext.Consumer, null, ({ radioGroup: { name, selectedValue, onChange } }) => (React.createElement(Wrapper, { className: classes, style: style },
        React.createElement("input", { ...rest, checked: value === selectedValue, className: "ixu-radio__native", name: name, onChange: () => onChange?.(value), type: "radio", value: value }),
        React.createElement("div", { className: "ixu-radio__faux" })))));
};
export default Radio;
//# sourceMappingURL=Radio.js.map